import _ from 'lodash';
import postcssJs from 'postcss-js';
import postCss from 'postcss';

function convertStyleKeyToCamelCase(styleKey) {
  return styleKey.replace(/\-(.)/g, (match1, match2) => match2.toUpperCase());
}

function checkStyleKeyRule(styleKeyWithRule) {
  return _.isArray(styleKeyWithRule) && styleKeyWithRule.length === 3;
}

function convertObjStyleToString(styleObject) {
  return _.map(styleObject, (style, key) => `${key}: ${style}`).join(';');
}

function convertInlineStyleToReactStyleObj(inlineStyle) {
  const styleObj = {};
  if (_.isEmpty(inlineStyle)) {
    return styleObj;
  }

  return postcssJs.objectify(postCss.parse(`div {${inlineStyle}}`)).div;
}

export {
  convertInlineStyleToReactStyleObj,
  convertObjStyleToString
};
